import React from 'react';
import ReactDatepicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ru from 'date-fns/locale/ru';
import { Wrapper } from './styledComponents';

const settings: Record<
  string,
  () => Pick<ReactDatePickerProps, 'minDate' | 'maxDate'>
> = {
  fromTodayToOneYearLater: () => {
    const today = new Date();
    const fromTodayToOneYearLater = new Date(
      new Date().setFullYear(today.getFullYear() + 1),
    );

    return {
      minDate: today,
      maxDate: fromTodayToOneYearLater,
    };
  },
};

type Props = ReactDatePickerProps & {
  dateFormat: string;
  dateStringValue?: string;
  setting?: keyof typeof settings;
  className?: string;
};

const Datepicker = ({
  setting = 'fromTodayToOneYearLater',
  className,
  dateStringValue,
  ...datepickerProps
}: Props) => {
  const settingsProps = settings[setting]();

  return (
    <Wrapper>
      <ReactDatepicker
        className={className}
        locale={ru}
        {...settingsProps}
        {...datepickerProps}
      />
    </Wrapper>
  );
};

export default Datepicker;
